import Api from '@/api'
// import domain from '@/config/domain'
const fetch = Api.fetch

export function getQiniuUploadToken() {
  return fetch.post({
    url: '/qiniu/token/get'
  }).then(data => {
    return data.token
  }).catch(e => {
    this.openNotify('danger', e.error_text || '获取token失败')
  })
}

export function getQiniuUploadExportToken() {
  return fetch.post({
    url: '/qiniu/token/get',
    params: {
      is_upload: true
    }
  }).then(data => {
    return data.token
  }).catch(e => {
    this.openNotify('danger', e.error_text || '获取token失败')
  })
}
